module.exports = __webpack_public_path__ + "static/media/L1.8278c7d9.jpg";